import { RouteConfig } from "QuorumGrassroots/framework/helpers/RouteRegistry"
import { ElectedOfficialsPage } from "./ElectedOfficialsPage"

export const electedOfficialsRoutes: RouteConfig[] = [
    {
        path: "/campaign/:id/elected-officials",
        component: ElectedOfficialsPage,
        requiresLogin: false,
        pageTitle: "Elected Officials",
        key: "campaign-elected-officials",
    },
]
